import React from 'react';
import './Event.css';
import logComponent from '../../common/logComponent';
import Event from './Event';
import { CardNextEventProvider } from '../../contexts/CardNextEventContext';
 
export default function EventCard({ moduleDescription }) {
  if (logComponent('EventCard')) { console.debug('EventCard rendered'); }


  return (
    <CardNextEventProvider>
      <Event moduleDescription={moduleDescription} />
    </CardNextEventProvider>
  );
}